'use client';

import { useCallback } from 'react';
import { TransactionConfirmationManager } from '@velocity-exchange/sdk';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import invariant from 'tiny-invariant';

/**
 * Hook for waiting for transaction confirmation
 */
export const useWaitForTxConfirm = () => {
	const connection = useVelocityStore((s) => s.connection.current);

	const waitForTxConfirm = useCallback(
		async (txSig: string) => {
			invariant(connection, 'Connection is required');

			const txConfirmationManager = new TransactionConfirmationManager(
				connection
			);
			const confirmedTxResult =
				await txConfirmationManager.confirmTransactionWebSocket(txSig);
			return confirmedTxResult;
		},
		[connection]
	);

	return { waitForTxConfirm };
};
